import { OrdoclicLapMessage } from '../types'

export * from './palette'

export const ucfirst = (s: string) => s.charAt(0).toUpperCase() + s.slice(1)

export const stringHasValue = (s: string) => s.trim().length > 0

export const isLapMessage = (data: unknown): data is OrdoclicLapMessage =>
    typeof data === 'object' && data !== null && 'type' in data
